"use strict";
exports.__esModule = true;
//# sourceMappingURL=global-setting-schema.type.js.map